<template>
    <div class="dashboard">
        <div class="row">

            <!-- <div class="col-md-12 d-flex justify-content-end">
                <div class="col-auto me-2">
                    <button type="button" class="btn btn-sm btn-outline-theme" data-bs-toggle="modal" data-bs-target="#downloadReportModal">
                        <i class="bi bi-arrow-down-circle pe-1"></i>Reports
                    </button>
                </div>
                <div class="col-auto">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        placeholder="Primary Search"
                        v-model="primarySearch"
                        @input="searchOrder"
                    />
                </div>
                <div v-if="primarySearch!==''" class="col-auto ms-2">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        placeholder="Secondary Search"
                        v-model="secondarySearch"
                        @input="searchOrder"
                    />
                </div>
            </div> -->
            <div v-if="primarySearch!==''" class="col-md-12">
                <div class="card">
                    <div class="card-header fw-bold text-black p-2">Search Order Results</div>
                    <div class="card-body overflow-auto p-2">
                        <div v-if="filterProcessing" class="d-flex justify-content-center">
                            <div class="spinner-grow text-dark" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                        <div v-else>
                            <table class="table hm-fs-12 align-middle table-hover table-sm hm-table-fixed">
                                <thead>
                                    <tr>
                                        <th scope="col" class="bg-theme">Date</th>
                                        <th scope="col" class="bg-theme">Client</th>
                                        <th scope="col" class="bg-theme">Address</th>
                                        <th scope="col" class="bg-theme text-center">Post Code</th>
                                        <th scope="col" class="bg-theme">Service</th>
                                        <th scope="col" class="bg-theme">Handyman</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-if="filteredData.orders.length"
                                        v-for="order in filteredData.orders"
                                        :key="order.id"
                                        @click="$goToPage('/admin/orders/'+order.order_number)"
                                        class="cursor-pointer"
                                    >
                                        <td>{{ $dateTimeFormat(order.booking_date, 'DD MMM YYYY') }}</td>
                                        <td class="text-capitalize">{{ order?.customer?.first_name }}</td>
                                        <td class="text-capitalize">{{ order?.address?.address }}</td>
                                        <td class="text-capitalize text-center">{{ order?.address?.postal_code }}</td>
                                        <td>{{ order?.order_items?.map(item => item?.service?.name).join(', ') }}</td>
                                        <td>
                                            {{ order?.handymans?.map(item => {
                                                let role = item?.roles[0];
                                                return role?.name==='provider' ? 'Admin' : item?.first_name
                                            }).join(', ') }}
                                        </td>
                                    </tr>
                                    <tr v-else>
                                        <td colspan="6" class="text-center">No results found</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <Test /> -->
        <!-- If user try to search anything then hide the original dashboard -->
        <template v-if="primarySearch===''">
            <div class="row">
                <!-- Display order summary -->
                <div class="col-lg-6 col-md-12">
                    <!-- Order summary -->
                    <div class="row hm-fs-12">
                        <div class="col-md-2 col-4 pe-md-0">
                            <div class="card info-card sales-card cursor-pointer bg-warning bg-opacity-50" @click="showOrderSummary('pending')">
                                <div class="card-body text-center p-1">
                                    <div class="fw-bold text-nowrap">Pending</div>
                                    <h6>{{ pendingOrders.length }}</h6>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-2 col-4 pe-md-0 ps-md-1">
                            <div class="card info-card sales-card cursor-pointer bg-info bg-opacity-50" @click="showOrderSummary('assigned')">
                                <div class="card-body text-center p-1">
                                    <div class="fw-bold text-nowrap">Assigned</div>
                                    <h6>{{ assignedOrders.length }}</h6>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-2 col-4 pe-md-0 ps-md-1">
                            <div class="card info-card sales-card cursor-pointer bg-success bg-opacity-50" @click="showOrderSummary('processing')">
                                <div class="card-body text-center p-1">
                                    <div class="fw-bold text-nowrap">Processing</div>
                                    <h6>{{ processingOrders.length }}</h6>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-2 col-4 pe-md-0 ps-md-1">
                            <div class="card info-card sales-card cursor-pointer bg-primary bg-opacity-50" @click="showOrderSummary('quotation')">
                                <div class="card-body text-center p-1">
                                    <div class="fw-bold text-nowrap">Quotations</div>
                                    <h6>{{ quotationOrders.length }}</h6>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-2 col-4 pe-md-0 ps-md-1">
                            <div class="card info-card sales-card cursor-pointer bg-info" @click="showOrderSummary('engineer_completed')">
                                <div class="card-body text-center p-1">
                                    <div class="fw-bold text-nowrap">E. Completed</div>
                                    <h6>{{ engineerCompletedOrders.length }}</h6>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-2 col-4 ps-md-1">
                            <div class="card info-card sales-card cursor-pointer bg-danger" @click="showOrderSummary('overdue')">
                                <div class="card-body text-center p-1">
                                    <div class="fw-bold text-nowrap">Overdue</div>
                                    <h6>{{ overDueOrders.length }}</h6>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Order summary -->
                    <OrderSummary
                        :orders="summaryDataModal.orders"
                        :title="summaryDataModal.title"
                        @close-order-summary="summaryDataModal.title = ''; summaryDataModal.orders = []"
                    />

                    <!-- Overdue tasks -->
                    <OverdueTasks />

                    <!-- Other info -->
                    <div class="row">
                        <div class="col-md-6">
                            <!-- Projects -->
                            <ProjectSummary></ProjectSummary>

                            <!-- Appointments -->
                            <AppointmentSummary></AppointmentSummary>
                        </div>
                        <div class="col-md-6">
                            <!-- Quotations -->
                            <QuotationSummary></QuotationSummary>

                            <!-- Tickets -->
                            <TicketSummary></TicketSummary>
                        </div>
                    </div>
                </div>

                <!-- Display today's jobs -->
                <div class="col-lg-6 col-md-12">
                    <TodayJobs></TodayJobs>
                    <PendingTasks />
                </div>
            </div>

            <HandymanSummary></HandymanSummary>

            <!-- Available handymans -->
            <!-- <AvailableHandyman></AvailableHandyman> -->

            <!-- Display Handyman wise tasks -->
            <TaskSummary></TaskSummary>

            <!-- Display scheduled services -->
            <DashboardScheduledServices></DashboardScheduledServices>
        </template>
        <!-- <FilterReports></FilterReports> -->

        <!-- Display order summary modal -->
        <div
            class="modal fade"
            id="viewSummaryModal"
            aria-hidden="true"
            tabindex="-1"
            data-backdrop="static"
            data-keyboard="false"
        >
            <div class="modal-dialog modal-dialog-scrollable modal-lg">
                <div class="modal-content bg-white">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ summaryDataModal.title }}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body g-3">
                        <div class="table-responsive">
                            <table class="table table-borderless hm-fs-12 align-middle table-striped">
                                <thead>
                                    <tr>
                                        <th class="bg-theme">Handyman</th>
                                        <th class="bg-theme">Client</th>
                                        <th class="bg-theme">Address</th>
                                        <th class="bg-theme">Postal Code</th>
                                        <th class="bg-theme">Phone</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="summaryDataModal.orders.length == 0">
                                        <td colspan="5" class="text-center">No orders found</td>
                                    </tr>
                                    <tr
                                        v-else
                                        v-for="order in summaryDataModal.orders"
                                        :key="order.id"
                                        :id="'order-' + order.id"
                                    >
                                        <td>
                                            {{
                                                order?.handymans?.map(item => {
                                                    // Check if handyman has provider role
                                                    const hasProviderRole = item?.roles?.some(role => role.name === 'provider');
                                                    return hasProviderRole ? 'Admin' : item?.name;
                                                }).join(', ')
                                            }}
                                        </td>
                                        <td>{{ order.customer.name }}</td>
                                        <td>{{ order.address.address + ', ' + order.address.address_1 }}</td>
                                        <td>{{ order.address.postal_code }}</td>
                                        <td>{{ order.customer.phone_number }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-danger" data-bs-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Right click context -->
    <vue-simple-context-menu
        element-id="handleRightClick"
        :options="rightClickOptions"
        ref="rightClickMenu"
        @option-clicked="handleRightClickMenuAction"
        :fixed="true"
    >
    </vue-simple-context-menu>
</template>
<script>
import { debounce } from 'lodash'; // Import debounce from lodash
import VueSimpleContextMenu from "vue-simple-context-menu";
import "vue-simple-context-menu/dist/vue-simple-context-menu.css";

import '@imengyu/vue3-context-menu/lib/vue3-context-menu.css'
import ContextMenu from '@imengyu/vue3-context-menu'

import TodayJobs from './TodayJobs';
import TaskSummary from './TaskSummary';
import DueDateSummary from './DueDateSummary';
import ProjectSummary from './ProjectSummary';
import AppointmentSummary from './AppointmentSummary';
import QuotationSummary from './QuotationSummary';
import TicketSummary from './TicketSummary';
import AvailableHandyman from './AvailableHandyman';
import Test from './Test';
import FilterReports from '../partials/FilterReports';
import HandymanSummary from './HandymanSummary';
import PendingTasks from './PendingTasks';
import OverdueTasks from './OverdueTasks.vue';
import DashboardScheduledServices from './DashboardScheduledServices.vue';

import { appMixin } from '../../mixin/appMixin';

export default {
    name: 'Dashboard',
    mixins: [appMixin],
    components: {
        TodayJobs,
        TaskSummary,
        DueDateSummary,
        ProjectSummary,
        AppointmentSummary,
        QuotationSummary,
        TicketSummary,
        AvailableHandyman,
        Test,
        FilterReports,
        HandymanSummary,
        PendingTasks,
        OverdueTasks,
        VueSimpleContextMenu,
        ContextMenu,
        DashboardScheduledServices,
    },
    data() {
        return {
            orderSummary: {
                pendingOrders: 0,
                assignedOrders: 0,
                processingOrders: 0,
                quotationOrders: 0,
                completedOrders: 0
            },
            filterProcessing: false,
            primarySearch: '',
            secondarySearch: '',
            debouncedFetchResults: null,
            filteredData: {
                orders: [],
                tasks: [],
                services: [],
                projects: [],
                quotations: [],
                appointments: [],
                open_tickets: [],
            },
            orders: [],
            summaryDataModal: {
                title: '',
                orders: [],
            },
            rightClickOptions: [],
            availableContextMenuOptions: {
                pending: [
                    {name: "Move To Assigned", action: "bucket-move", moveToStatus: "assigned", moveFromStatus: "pending" },
                    {name: "View Order", action: "order-view" },
                    {name: "View Customer", action: "view-customer" },
                    {name: "Add Attachment", action: "add-attachment" },
                    {name: "Cancel Order", action: "cancel" },
                    {name: "Duplicate Order", action: "duplicate" },
                ],
                assigned: [
                    {name: "Move To Processing", action: "bucket-move", moveToStatus: "processing", moveFromStatus: "assigned"},
                    {name: "Back To Pending", action: "bucket-move", moveToStatus: "pending", moveFromStatus: "assigned"},
                    {name: "View Order", action: "order-view" },
                    {name: "View Customer", action: "view-customer" },
                    {name: "Add Attachment", action: "add-attachment" },
                    {name: "Reassign Order", action: "reassign-order" },
                    {name: "Cancel Order", action: "cancel" },
                    {name: "Duplicate Order", action: "duplicate" },
                ],
                processing: [
                    {name: "Back To Pending", action: "bucket-move", moveToStatus: "pending", moveFromStatus: "processing"},
                    {name: "Move To Quotation", action: "bucket-move", moveToStatus: "quotation", moveFromStatus: "processing"},
                    {name: "Move To Completed", action: "bucket-move", moveToStatus: "completed", moveFromStatus: "processing"},
                    {name: "Back To Assigned", action: "bucket-move", moveToStatus: "assigned", moveFromStatus: "processing"},
                    {name: "View Order", action: "order-view" },
                    {name: "View Customer", action: "view-customer" },
                    {name: "Add Attachment", action: "add-attachment" },
                    {name: "Cancel Order", action: "cancel" },
                    {name: "Duplicate Order", action: "duplicate" },
                ],
                quotation: [
                    {name: "Move To Completed", action: "bucket-move", moveToStatus: "completed", moveFromStatus: "quotation"},
                    {name: "Back To Processing", action: "bucket-move", moveToStatus: "processing", moveFromStatus: "quotation"},
                    {name: "Quotation Declined", action: "bucket-move", moveToStatus: "declined", moveFromStatus: "quotation"},
                    {name: "Quotation Approved", action: "bucket-move", moveToStatus: "pending", moveFromStatus: "quotation"},
                    {name: "View Order", action: "order-view" },
                    {name: "View Customer", action: "view-customer" },
                    {name: "Add Attachment", action: "add-attachment" },
                    {name: "Cancel Order", action: "cancel" },
                    {name: "Duplicate Order", action: "duplicate" },
                ],
                engineer_completed: [
                    {name: "Move To Completed",action: "bucket-move",moveToStatus: "completed",moveFromStatus: "engineer_completed"},
                    {name: "Move To Quotation", action: "bucket-move", moveToStatus: "quotation", moveFromStatus: "processing"},
                    {name: "Back To Processing",action: "bucket-move",moveToStatus: "processing",moveFromStatus: "engineer_completed"},
                    {name: "View Order", action: "order-view" },
                    {name: "View Customer", action: "view-customer" },
                    {name: "Add Attachment", action: "add-attachment" },
                    {name: "Cancel Order", action: "cancel" },
                    {name: "Duplicate Order", action: "duplicate" },
                ],
                completed: [
                    {name: "Back To Quotation", action: "bucket-move", moveToStatus: "quotation", moveFromStatus: "completed"},
                    {name: "View Order", action: "order-view" },
                    {name: "View Customer", action: "view-customer" },
                    {name: "View Invoice", action: "invoice-view" },
                    {name: "Add Attachment", action: "add-attachment" },
                    {name: "Cancel Order", action: "cancel" },
                    {name: "Duplicate Order", action: "duplicate" },
                ],
                declined: [
                    {name: "Back To Quotation", action: "bucket-move", moveToStatus: "quotation", moveFromStatus: "declined"},
                    {name: "View Order", action: "order-view" },
                    {name: "View Customer", action: "view-customer" },
                    {name: "View Invoice", action: "invoice-view" },
                    {name: "Add Attachment", action: "add-attachment" },
                    {name: "Cancel Order", action: "cancel" },
                    {name: "Duplicate Order", action: "duplicate" },
                ],
                temporary: [
                    {name: "Approve Order", action: "approve_order"},
                    {name: "Move To Assigned", action: "bucket-move", moveToStatus: "assigned", moveFromStatus: "pending" },
                    {name: "View Order", action: "order-view" },
                    {name: "View Customer", action: "view-customer" },
                    {name: "Add Attachment", action: "add-attachment" },
                    {name: "Cancel Order", action: "cancel" },
                    {name: "Duplicate Order", action: "duplicate" },
                ],
            },
            activeOrder: null,
        }
    },

    created() {
        this.debouncedFetchResults = debounce(this.fetchFilteredResults, 300);
    },

    mounted() {
        this.getStats();

        // Listen to order cancelled event
        this.$emitter.on('refresh-order-list', (data) => {
            this.getStats('order_summary');
        });
    },
    computed: {
        ordersCount() {
            return this.orders.length;
        },
        pendingOrders() {
            return this.orders.filter(order => order.status === 'pending');
        },
        assignedOrders() {
            return this.orders.filter(order => order.status === 'assigned');
        },
        processingOrders() {
            return this.orders.filter(order => order.status === 'processing');
        },
        quotationOrders() {
            return this.orders.filter(order => order.status === 'quotation');
        },
        engineerCompletedOrders() {
            return this.orders.filter(order => order.status === 'engineer_completed');
        },
        overDueOrders() {
            // Filter the order where booking_date is less than today
            // and status in ['assigned', 'processing']
            const today = this.moment().format('YYYY-MM-DD');
            return this.orders.filter(order => {
                const bookingDate = this.momentObj(order.booking_date).format('YYYY-MM-DD');
                return bookingDate < today && ['assigned', 'processing'].includes(order.status);
            });
        },
    },
    methods: {
        getStats(action = 'order_summary') {
            let self = this;
            axios.post('/admin/dashboard/stats?action=' + action, {action: action})
                .then(response => {
                    // Get order summary
                    if (action == 'order_summary') {
                        self.orders = response.data.orders;

                        // Check if activeOrder is not null
                        if (self.activeOrder) {
                            self.summaryDataModal.orders = self.getOrderSummary(self.activeOrder);
                        }
                    }
                })
        },
        gotoPage(url, newTab = false) {
            if (newTab) {
                window.open(url, '_blank');
                return;
            }
            else {
                window.location.href = url;
            }
        },

        searchOrder() {
            const leadingTrimmed = this.primarySearch.replace(/^\s+/, '');

            // Set primarySearch based on whether the trimmed input is empty
            this.primarySearch = leadingTrimmed.length > 0 ? leadingTrimmed : '';

            // If search is not empty
            if (this.primarySearch) {
                this.filterProcessing = true;
            }

            // Filter the secondary search
            const leadingTrimmedSecondary = this.secondarySearch.replace(/^\s+/, '');
            this.secondarySearch = leadingTrimmedSecondary.length > 0 ? leadingTrimmedSecondary : '';

            // If secondary search is not empty
            if (this.secondarySearch) {
                this.filterProcessing = true;
            }

            // Trigger search
            this.debouncedFetchResults();
        },
        async fetchFilteredResults() {
            let self = this;
            await axios.post('/admin/dashboard/search', {primary_search: this.primarySearch, secondary_search: this.secondarySearch})
                .then(response => {
                    self.filteredData.orders = response.data.orders;
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    self.filterProcessing = false;
                });
        },
        showOrderSummary(status) {
            // First check if current and already selected status is same
            if (this.summaryDataModal.title == this.capitalize(status.replace('_', ' '))) {
                this.summaryDataModal.title = '';
                this.summaryDataModal.orders = [];
                return;
            }

            this.activeOrder = status;
            this.summaryDataModal.title = this.capitalize(status.replace('_', ' '));
            this.summaryDataModal.orders = this.getOrderSummary(status);
        },
        onContextMenu(event, order) {
            console.log(order);
            // Prevent default context menu
            event.preventDefault();

            // Get the right click menu based on the order status
            this.rightClickOptions = this.availableContextMenuOptions[order.status] || [];
            //this.$refs.rightClickMenu.showMenu(event, order);
            //this.$refs.contextMenu.showMenu(event, order)

            //show your menu
            ContextMenu.showContextMenu({
                x: event.x,
                y: event.y,
                items: [
                {
                    label: "A menu item",
                    onClick: () => {
                    alert("You click a menu item");
                    }
                },
                {
                    label: "A submenu",
                    children: [
                    { label: "Item1" },
                    { label: "Item2" },
                    { label: "Item3" },
                    ]
                },
                ]
            });
        },
        getOrderSummary(status) {
            let summaryOrders = [];
            if(status == 'pending') {
                summaryOrders = this.pendingOrders;
            }
            else if(status == 'assigned') {
                summaryOrders = this.assignedOrders;
            }
            else if(status == 'processing') {
                summaryOrders = this.processingOrders;
            }
            else if(status == 'quotation') {
                summaryOrders = this.quotationOrders;
            }
            else if(status == 'engineer_completed') {
                summaryOrders = this.engineerCompletedOrders;
            }
            else if(status == 'overdue') {
                summaryOrders = this.overDueOrders;
            }
            return summaryOrders;
        },
        handleRightClickMenuAction(event) {
            console.log(event);
        }
    }
}
</script>
